import { object, string } from "yup";

export const addIncorporateFilingSchema = object({
  entity: string().required("Entity required"),
  productId: string().required("Structure required"),
});
